(function ($) {
    const popoverSelector = '[data-toggle=popover]';

    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    $.fn.enablePopovers = function (options) {
        if (!options) {
            options = { trigger: 'focus' };
        }

        $(popoverSelector, this).popover(options);

        return this;
    };
}(jQuery));